module.exports = __webpack_public_path__ + "static/media/bksc_logo.fc25388c.svg";